export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/5bdd198b-b604-492c-aeeb-4c16a8aaf3f5.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/5ed61ab1-d6a1-473c-af9e-0b20bcf4f2fd.png',
};
